<template>
  <div>
    <img v-if="logoSrc" :src="logoSrc" class="hero"/>
    <div v-else-if="hasConfig && !isMobile" v-html="config.html"></div>
    <div v-else-if="hasConfig && isMobile">
      <img v-for="(src,i) in mobileImages" :key="i" :src="src" class="thumb"/>
    </div>
  </div>
 </template>

<script>
export default {
  name: 'bulmaOneImageHtml',
  props: { id: String },
  data() { return { isMobile: false } },
  computed: {
    config() { const o=this.$store.getters.getObject(this.id); return o ? o.data : {}; },
    hasConfig() { return !!(this.config && (this.config.html || this.config.images)); },
    isDark() { return (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches); },
    logoSrc() {
      const sq = this.config && this.config.squareLogo;
      const lg = this.config && this.config.logo;
      if (this.isDark) {
        if (sq && (sq.darkImg || sq.img)) return sq.darkImg || sq.img;
        if (lg && (lg.darkImg || lg.img)) return lg.darkImg || lg.img;
      } else {
        if (sq && sq.img) return sq.img;
        if (lg && lg.img) return lg.img;
      }
      return '';
    },
    imagesFromHtml() {
      const html=this.config && this.config.html ? this.config.html : '';
      const re=/<img\s[^>]*src=['"]([^'"]+)['"][^>]*>/gi;
      const out=[]; let m; while((m=re.exec(html))!==null){ out.push(m[1]); }
      return out;
    },
    mobileImages() {
      const arr=Array.isArray(this.config.images) ? this.config.images : this.imagesFromHtml;
      if(!arr || !arr.length) return [];
      return arr.slice(-2);
    }
  },
  mounted() {
    const fn=()=>{ this.isMobile=window.matchMedia('(max-width: 600px)').matches };
    fn(); window.addEventListener('resize', fn);
  },
  beforeDestroy() {
    window.removeEventListener('resize', ()=>{});
  }
}
</script>

<style scoped>
.hero{ width:100%; height:auto; max-height:70vh; object-fit:contain; display:block }
.thumb{ width:100%; object-fit:cover; display:block; margin-bottom:8px }
</style>